<template>
  <div class="comment-template-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" class="ct-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运维管理</el-breadcrumb-item>
      <el-breadcrumb-item>评价模版</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="ct-card" shadow="hover">
      <!-- 工具栏 -->
      <div class="ct-toolbar">
        <el-select
          v-model="query.scoreType"
          placeholder="评分类型"
          clearable
          size="small"
          style="width: 130px"
          @change="fetchList"
        >
          <el-option label="好评" value="good"></el-option>
          <el-option label="中评" value="mid"></el-option>
          <el-option label="差评" value="bad"></el-option>
        </el-select>
        <el-button type="primary" size="small" icon="el-icon-search" @click="fetchList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="success" size="small" icon="el-icon-plus" @click="openAdd">新增模版</el-button>
      </div>

      <!-- 数据表格 -->
      <el-table :data="list" border size="small" v-loading="loading" empty-text="暂无模版">
        <el-table-column label="评分类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scoreTagType(scope.row.scoreType)" size="small">{{ scoreLabel(scope.row.scoreType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="文案内容" min-width="420">
          <template slot-scope="scope">
            <span class="ct-content">{{ scope.row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column label="启用" width="70" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.enabled"
              @change="val => handleToggleEnabled(scope.row, val)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" class="ct-del-btn" @click="handleRemove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="form._id ? '编辑模版' : '新增模版'"
      :visible.sync="dialogVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form label-width="90px" size="small">
        <el-form-item label="评分类型">
          <el-select v-model="form.scoreType" style="width: 100%">
            <el-option label="好评" value="good"></el-option>
            <el-option label="中评" value="mid"></el-option>
            <el-option label="差评" value="bad"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文案内容">
          <el-input
            type="textarea"
            :rows="5"
            v-model="form.content"
            maxlength="200"
            show-word-limit
            placeholder="请输入回复文案"
          ></el-input>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.enabled"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CommentTemplate',
  data () {
    return {
      loading: false,
      saving: false,
      list: [],
      query: {
        scoreType: ''
      },
      dialogVisible: false,
      form: {
        _id: '',
        scoreType: 'good',
        content: '',
        enabled: true
      }
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const params = {}
        if (this.query.scoreType) params.scoreType = this.query.scoreType
        const { data: res } = await this.$http.get('yunwei/commentTemplate/list', { params })
        if (res.meta.status === 200) {
          this.list = res.data || []
        } else {
          this.$message.error(res.meta.msg || '获取列表失败')
        }
      } catch (err) {
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },

    resetQuery () {
      this.query.scoreType = ''
      this.fetchList()
    },

    openAdd () {
      this.form = { _id: '', scoreType: 'good', content: '', enabled: true }
      this.dialogVisible = true
    },

    openEdit (row) {
      this.form = {
        _id: row._id,
        scoreType: row.scoreType,
        content: row.content,
        enabled: row.enabled
      }
      this.dialogVisible = true
    },

    async submitForm () {
      const content = (this.form.content || '').trim()
      if (!content) return this.$message.warning('文案内容不能为空')
      if (content.length > 200) return this.$message.warning('文案内容不能超过200字')
      this.saving = true
      try {
        let res
        if (this.form._id) {
          res = await this.$http.put(`yunwei/commentTemplate/modify/${this.form._id}`, {
            scoreType: this.form.scoreType,
            content,
            enabled: this.form.enabled
          })
        } else {
          res = await this.$http.post('yunwei/commentTemplate/add', {
            scoreType: this.form.scoreType,
            content,
            enabled: this.form.enabled
          })
        }
        if (res.data.meta.status === 200) {
          this.$message.success(this.form._id ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.fetchList()
        } else {
          this.$message.error(res.data.meta.msg || '保存失败')
        }
      } catch (err) {
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },

    async handleToggleEnabled (row, val) {
      try {
        const { data: res } = await this.$http.put(`yunwei/commentTemplate/modify/${row._id}`, { enabled: val })
        if (res.meta.status === 200) {
          row.enabled = val
        } else {
          this.$message.error(res.meta.msg || '修改失败')
        }
      } catch (err) {
        this.$message.error('修改失败')
      }
    },

    async handleRemove (row) {
      try {
        await this.$confirm('确定删除该模版?', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      try {
        const { data: res } = await this.$http.delete(`yunwei/commentTemplate/remove/${row._id}`)
        if (res.meta.status === 200) {
          this.$message.success('删除成功')
          this.fetchList()
        } else {
          this.$message.error(res.meta.msg || '删除失败')
        }
      } catch (err) {
        this.$message.error('删除失败')
      }
    },

    scoreLabel (type) {
      return { good: '好评', mid: '中评', bad: '差评' }[type] || type
    },

    scoreTagType (type) {
      return { good: 'success', mid: 'info', bad: 'danger' }[type] || ''
    }
  }
}
</script>

<style scoped>
.ct-breadcrumb {
  margin-bottom: 12px;
}
.ct-toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}
.ct-content {
  display: inline-block;
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.5;
  color: #606266;
}
.ct-del-btn {
  color: #f56c6c;
}
.ct-del-btn:hover {
  color: #f78989;
}
</style>
